import {COINS_COLOR_DARK, WIN_POINTS_COLOR_DARK} from '../styles/constants';

// Типы реакций, которые игроки отправляют друг другу по ходу сетевого матча
// (см. openspec/changes/reaction-messages). Иконка задается одним из трех
// способов: emoji (текстом), iconSrc (готовая картинка) либо maskSrc+maskColor
// (белый/черный силуэт, тонируемый маской — прием как у .shop-tab-icon_factions).
// Порядок массива = порядок в гриде панели отправки, столбец за столбцом
// (грид залит через grid-auto-flow: column, 5 столбцов по 4 реакции)
export const REACTION_TYPES = [
  // 1 столбец
  {id: 'swear', title: 'Брань', iconSrc: '/img/icons/swear.png'},
  {id: 'clown', title: 'Клоун', iconSrc: '/img/icons/clown.png'},
  {id: 'crazy', title: 'Сумасшедший', iconSrc: '/img/icons/crazy.png'},
  {id: 'mimicry', title: 'Передразнивание', iconSrc: '/img/icons/tongue.png'},
  // 2 столбец
  {id: 'embarrassed', title: 'Потно', iconSrc: '/img/icons/embarrassed.png'},
  {id: 'gloat', title: 'Злорадство', iconSrc: '/img/icons/gloat.png'},
  {id: 'mockery', title: 'Насмешка', iconSrc: '/img/icons/laughing.png'},
  {id: 'suspicious', title: 'Подозрительно', iconSrc: '/img/icons/expressionless.png'},
  // 3 столбец
  {id: 'angel', title: 'Ангел', iconSrc: '/img/icons/angel.png'},
  {id: 'love', title: 'Любовь', iconSrc: '/img/icons/in_love.png'},
  {id: 'frustration', title: 'Досада', iconSrc: '/img/icons/crying.png'},
  {id: 'cool', title: 'Круто', iconSrc: '/img/icons/cool.png'},
  // 4 столбец
  {id: 'gratitude', title: 'Благодарность', emoji: '🙏'},
  {id: 'peace_offer', title: 'Предложение мира', emoji: '🕊️'},
  {id: 'alliance_offer', title: 'Предложение союза', emoji: '🤝'},
  {id: 'greeting', title: 'Приветствие', emoji: '👋'},
  // 5 столбец
  {id: 'threat', title: 'Угроза', iconSrc: '/img/icons/barracks red.png'},
  {
    id: 'trade_offer',
    title: 'Предложение торговли',
    maskSrc: '/img/icons/guild_black.png',
    maskColor: COINS_COLOR_DARK
  },
  {
    id: 'culture_offer',
    title: 'Предложение культурного обмена',
    maskSrc: '/img/icons/temple_black.png',
    maskColor: WIN_POINTS_COLOR_DARK
  },
  {
    id: 'faction',
    title: 'Фракционная озвучка',
    iconSrc: '/img/icons/banner.png',
    overlayMaskSrc: '/img/icons/volume.png'
  },
];

export const getReactionTypeConfig = (reactionTypeId) =>
  REACTION_TYPES.find((reaction) => reaction.id === reactionTypeId) || null;

// Адресат "Всем" — общий для панели отправки, тоста и симуляции ботов.
// Живет здесь (а не в ReactionsPanel, как раньше), чтобы утилиты вроде
// scheduleBotReply могли на него ссылаться без циклического импорта
// компонента
export const REACTION_RECIPIENT_ALL = 'all';
